import { Box } from "@mui/material";

import { erasmusRequests } from "api/erasmusApi";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { ErasmusRegularStudentDocuments } from "utils/constants";
import CertificateOfArrivalButton from "../../Partials/CertificateOfArrivalButton";
import GenerateDocumentButton from "../../Partials/GenerateDocumentButton";

const DocumentGenerationSection = ({ id, userInfo }) => {
  const available = ErasmusRegularStudentDocuments.filter(
    document => document.statuses.includes(userInfo?.status) && !(document.excludesBip && userInfo?.isBip),
  );

  if (!available.length) return null;

  return (
    <SecuredComponent permission={permissions.canManageErasmusRegularStudents}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 1,
          "& .MuiButton-root": { margin: 0 },
        }}
      >
        {available.map(({ label, path, advancesStatus, requiresForm }) =>
          requiresForm ? (
            <CertificateOfArrivalButton
              key={path}
              buildUrl={params => erasmusRequests.getIncomingStudentsRegularCertificateOfArrival(id, params)}
              fileName={path}
              label={label}
            />
          ) : (
            <GenerateDocumentButton
              key={path}
              url={erasmusRequests.getIncomingStudentsRegularDocument(id, path)}
              fileName={path}
              label={label}
              refreshAfter={advancesStatus}
            />
          ),
        )}
      </Box>
    </SecuredComponent>
  );
};

export default DocumentGenerationSection;
